module.exports = __webpack_public_path__ + "img/7899.f66d60f5.png";